import axiosInstance from "./index.services";

export async function SiteSettingsHeader(data:any){
  const response = await axiosInstance.post("/landingpage/", data);
  return response;
}

export async function FetchSiteSettings(){
    const response = await axiosInstance.get("landingpage");
    return response;
}

export async function DiffEmailSettings(){
    const response = await axiosInstance.get("emailsend");
    return response;
}

export async function SiteEmailsPut(data:any){
  const response = await axiosInstance.patch(`/emailsend/${data.id}/`, {"email":data?.email});
  return response;
}